import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { VhViethasWebAPPEndUser } from 'vhwebapp';
import path from '../../../config/path/path.json'
@Component({
  selector: 'app-webapp-highlight-products-c001-user',
  templateUrl: './webapp-highlight-products-c001-user.component.html',
  styleUrls: ['./webapp-highlight-products-c001-user.component.scss']
})
export class WebappHighlightProductsC001UserComponent implements OnInit {
  @Input() routeParams: any;
  @Input() id_fields: any;
  listShowCurrent: any;
  isMobile: boolean;
  collapse: number = 2;
  constructor(
    public platform: Platform,
    private router: Router,
    private vhViethasWebAPPEndUser: VhViethasWebAPPEndUser

  ) {
    if (platform.width() < 768) this.isMobile = true
    else if (platform.is("android") || platform.is("ios")) this.isMobile = false
    else this.isMobile = false
  }

  ngOnInit(): void {
    this.getProducts()
  }

  getProducts() {
    this.vhViethasWebAPPEndUser.getComponentContentsByFields('webapp_fields_c001_items', { id_webapp_fields_c001: { $eq: this.id_fields }, webapp_products_hidden: { $eq: true }, webapp_products_highlight: { $eq: true } }, {}, {}, 0, 0)
      .then((response: any) => {
        if (response.vcode === 0) {
          //-----------your code-----------
          this.listShowCurrent = response.data;
          if (this.isMobile == true) {
            this.slides = this.chunk(this.listShowCurrent, 2);
          } else {
            this.slides = this.chunk(this.listShowCurrent, 4);
          }
        }
      }, error => {
        console.log('error', error)
      })
  }

  /**Hàm xác định là số hay chuỗi
   *
   * @param val
   * @returns
   */
  isNumber(val): boolean { return typeof val === 'number'; }
  /**Hàm kiểm tra có khuyến mãi
    *
     * @param _value
     * @return true false
     */
  checkDiscount(_value): boolean {
    if (_value) {
      return true;
    }
    return false;
  }
  /** Hàm tính số tiền còn lại khi đã khuyến mãi
 *
 *
  * @param _price
  * @param _discount
  * @return number
  */
  sum(_price, _discount): number {
    let discounted = (_discount / _price) * 100;
    return Math.round(100 - discounted);
  }
  slides: any = [[]];
  /** Hàm thực hiện tách mảng
   *
   * @param arr         // mảng truyền vào
   * @param chunkSize   //kích thước từng mảng sẽ tách
   * @returns     // trả về 1 mảng 2 chiều
   */
  chunk(arr: any, chunkSize: any) {
    let R = [];
    for (let i = 0, len = arr.length; i < len; i += chunkSize) {
      R.push(arr.slice(i, i + chunkSize));
    }
    return R;
  }
  /** Hàm thực hiện thay đổi xem thêm hay thu gọn khi xem conntent
   *
   */
  changecCollapse() {
    if (this.collapse == 1) {
      this.collapse = 2;
    } else {
      this.collapse = 1
    }
  }

  nameFormatFn(_name): string {
    _name = _name.split("-").join(" ");
    return _name.split(" ").join("-");
  }

  gotoDetail(pro) {
    this.router.navigateByUrl(path.link + '/' + this.routeParams.id_field + '/' + pro._id)
  }
}
